import React from "react";
import Cover from "./assets/components/cover";
import { RESTAPI, Wallet } from "./config";

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      alert: null,
    };
  }

  componentDidMount() {
    this.connect();
  }

  async connect() {
    const { address } = await Wallet.connectWallet();

    if (address) {
      const { status } = await RESTAPI.getDataAboutNFTs(address);
      
      if (status === "success") {
        this.setState({
          alert: {
            message: `Thank you, now you have access to the Faded Arcade and the Sunnyvale pixelverse. It should load automatically, but if not, <a href="https://play.fadedarcade.com/?wallet_address=${address}">CLICK HERE</a> to continue.`,
          },
        });

        setTimeout(() => {
          window.location.replace(
            `https://play.fadedarcade.com/?wallet_address=${address}`
          );
        }, 3000);
      } else {
        this.setState({
          alert: {
            message: `Verification check failure! Faded Arcade NFT is not found. If you wish to access Sunnyvale and the Faded Arcade you require a Faded Arcade NFT find out more <a href="https://fadedarcade.com/">HERE</a>.`,
          },
        });
      }
    }
  }

  render() {
    return (
      <div>
        <Cover
          handleConnect={this.connect.bind(this)}
          alert={this.state.alert}
        />
      </div>
    );
  }
}

export default App;
